interface TableSkeletonRowsProps {
  rows?: number;
  testId?: string;
}

function TableSkeletonRows({ rows = 3, testId }: TableSkeletonRowsProps) {
  return (
    <div className="space-y-2" data-testid={testId}>
      {Array.from({ length: rows }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="h-10 w-full rounded bg-muted animate-pulse" />
      ))}
    </div>
  );
}

export { TableSkeletonRows };
export type { TableSkeletonRowsProps };
